import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { injectScreenIndex } from '../../flow/flow-routing';
import { FunnelFlowService } from '../../services/funnel-flow.service';

@Component({
  selector: 'app-format-input',
  templateUrl: './format-input.component.html',
  styleUrl: './format-input.component.scss',
  imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatButtonModule],
})
export class FormatInputComponent {
  @ViewChild('formatInput') formatInput!: ElementRef;

  format = new FormControl('', [Validators.required]);

  private readonly screenIndex = injectScreenIndex();

  constructor(private flowService: FunnelFlowService) {}

  enterPressed(): void {
    if (this.isInvalid()) {
      return;
    }

    this.formatInput.nativeElement.blur();

    this.proceed();
  }

  continueButtonClicked(): void {
    if (this.isInvalid()) {
      return;
    }

    this.proceed();
  }

  proceed(): void {
    this.flowService.handleFinishedManualFormat(this.screenIndex, this.format.value!.trim());
  }

  isInvalid(): boolean {
    return !this.format.value?.trim() || this.format.invalid;
  }
}
